const Update = ({ color, type }) => {
  const regular = (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.53323 3.13061V8.43928L11.4706 10.9459C11.6881 11.1305 11.7127 11.4546 11.5281 11.668C11.4255 11.7869 11.2819 11.8485 11.1383 11.8485C11.0194 11.8485 10.9004 11.8075 10.806 11.7254L7.68811 9.06696C7.57323 8.9685 7.50759 8.82902 7.50759 8.67722V3.13061C7.50759 2.84753 7.73734 2.61779 8.02041 2.61779C8.30349 2.61779 8.53323 2.84753 8.53323 3.13061ZM5.38659 13.9736C5.12813 13.8587 4.82454 13.9777 4.70967 14.2361C4.5948 14.4946 4.71377 14.7982 4.97223 14.9131C5.0748 14.9582 5.18146 15.0033 5.28813 15.0443C6.16196 15.3849 7.08914 15.5531 8.02041 15.5531C8.79579 15.5531 9.57117 15.4341 10.3137 15.1961C12.2378 14.5849 13.805 13.2597 14.7321 11.4669C15.6593 9.67414 15.8316 7.62698 15.2162 5.70699C13.9527 1.73575 9.69424 -0.463208 5.72299 0.804473C1.75585 2.06805 -0.443103 6.32647 0.820475 10.2977C1.12816 11.2618 1.62047 12.1439 2.26456 12.9028L0.972269 12.8044C0.693297 12.7797 0.443043 12.9931 0.42253 13.2762C0.402018 13.5592 0.611247 13.8054 0.894321 13.8259L3.54866 14.0269C3.70045 14.0392 3.84814 13.9818 3.95481 13.8751C3.97122 13.8587 3.98352 13.8423 3.99583 13.8259C3.99993 13.8218 3.99993 13.8177 4.00404 13.8136C4.12301 13.6618 4.14762 13.469 4.07788 13.3008L3.82763 10.8228C3.79891 10.5398 3.55276 10.3387 3.26558 10.3634C2.98251 10.3921 2.77738 10.6423 2.8061 10.9254L2.92507 12.0987C2.42456 11.4751 2.03893 10.7613 1.79277 9.98593C0.697399 6.55622 2.60097 2.87625 6.03068 1.78088C9.4604 0.6855 13.1404 2.58907 14.2357 6.01879C14.765 7.68031 14.6173 9.4485 13.8173 10.9993C13.0173 12.55 11.6635 13.6946 10.0019 14.2238C8.56194 14.6833 7.06042 14.6382 5.65736 14.0926C5.5671 14.0515 5.47684 14.0146 5.38659 13.9736Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Update;
